import { RESTRICTION_FLAGS } from 'constants/offer';

import type { TOffer } from 'shared/types/TRankingService';

export const isPreApprovalOffer = (offer: TOffer) =>
  !!offer?.additionalInfo?.restrictionFlags?.includes(RESTRICTION_FLAGS.EXACT_CONDITION_OFFER);
